// © 2026 Orpyx Medical Technologies Inc.
import {TableCell, TableRow} from "@material-ui/core";
import {PatientsListActionRequiredAlerts} from "../patients-list-action-required-alerts/patients-list-action-required-alerts";
import {DateTimePipe, fullNamePipe} from "orpyx-web-common";
import * as React from "react";
import {memo} from "react";
import {PatientsListTableItemProps} from "./patients-list-table-item.interface";
import {PatientStatusClassNames} from "../../enum/patient-status";
import {usePatientsListTableItemStyle} from "./patients-list-table-item.style";
import {PatientsListNamePortalLink} from "../patients-list-name-portal-link/patients-list-name-portal-link";
import {PatientsListOpenInPortalButton} from "../patients-list-open-in-portal-button/patients-list-open-in-portal-button";
import {statusLastChangedPipe} from "./status-last-changed.pipe";

export const PatientsListTableItem = memo((props: PatientsListTableItemProps) => {
    const classes = usePatientsListTableItemStyle();
    const patient = props.patient;
    const statusLabel = props.canDisplayStatus ? patient.statusName : undefined;
    const statusClass = PatientStatusClassNames(classes, statusLabel);

    return (
        <TableRow
            key={patient.patientId}
            onClick={() => props.onPatientSelected(patient)}
            className={statusClass.row ?? ''}
            hover
        >
            {props.canDisplayStatus && <TableCell>
                {statusLabel &&
                    <span className={`${classes.statusChip} ${statusClass.chip ?? ''}`}>
                        {statusLabel}
                    </span>}
            </TableCell>}

            {props.canDisplayActionRequiredAlerts && <TableCell>
                <PatientsListActionRequiredAlerts alerts={patient.actionRequiredAlerts}/>
            </TableCell>}
            <TableCell>
                {props.canDisplayPortalLink
                    ? <PatientsListNamePortalLink patient={patient}/>
                    : fullNamePipe(patient)}
            </TableCell>
            <TableCell>{patient.patientId}</TableCell>
            <TableCell>{patient.clientPatientIdentifier}</TableCell>
            {props.canDisplayDateOfPatientAuthorization && <TableCell>{DateTimePipe(patient.allowAccessStartDate)}</TableCell>}

            {props.canDisplayDaysSinceLastReview && <TableCell>{patient.daysSinceLastReview}</TableCell>}
            {props.canDisplayAllowAccessEndDate && <TableCell>{DateTimePipe(patient.allowAccessEndDate)}</TableCell>}

            {props.canDisplayInsoleSerialNumbers && <>
                <TableCell>
                    {patient.product?.leftInsoleSerialNumber}
                </TableCell>
                <TableCell>
                    {patient.product?.rightInsoleSerialNumber}
                </TableCell>
            </>}

            {props.canDisplayLastStatusUpdatedAt && <TableCell>
                {statusLastChangedPipe(patient.lastStatusUpdatedAt)}
            </TableCell>}

            {props.canDisplayOpenInPortalButton && <TableCell>
                <PatientsListOpenInPortalButton patient={patient}/>
            </TableCell>}
        </TableRow>
    );
});
